// extracted by mini-css-extract-plugin
export default {"loader":"loading-spinner_loader__xQmf4","ReceiptPage":"loading-spinner_ReceiptPage__r5DJp"};